import { tagInfo, phraseInfo } from "./constants";

const TagLabel = ({ element, isSelected }) => {
  const allTagInfo = { ...tagInfo, ...phraseInfo };
  return (
    <>
      {element.groupType !== "" && (
        <div
          style={{
            position: "absolute",
            top: "60px", // Flex 박스 바로 위로 이동
            left: "50%",
            transform: "translateX(-50%)", // 수평 중앙 정렬
            fontSize: "16px",

            width: "200px",
            textAlign: "center",
            color: allTagInfo[element.groupType].color,
          }}
        >
          {!isSelected ? allTagInfo[element.groupType].text : " "}
        </div>
      )}
    </>
  );
};

export default TagLabel;
